"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadGPTScript = loadGPTScript;

function doloadGPTScript(resolve, reject) {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  var scriptTag = document.createElement('script');
  scriptTag.src = "".concat(document.location.protocol, "//securepubads.g.doubleclick.net/tag/js/gpt.js");
  scriptTag.async = true;
  scriptTag.type = 'text/javascript';

  scriptTag.onerror = function scriptTagOnError(errs) {
    reject(errs);
  };

  scriptTag.onload = function scriptTagOnLoad() {
    resolve(window.googletag);
  };

  document.getElementsByTagName('head')[0].appendChild(scriptTag);
}

function loadGPTScript() {
  /*
  original implemenation of react-gpt was to load gpt.js themselves, this was causing an issue with edmunds -
  because we already load gpt.js via script tag ourselves (which is faster), their loading was resulting in
  duplicate execution of the script (when loading the same script twice browsers will not download twice but they
  will execute it twice). This is a waste in terms of performance. Furthermore, the the browser would queue the
  script execution initiated by them to the end of browser's event queue, which would further delay when it happens
   Furthermore, their implementation inside of their manager waits for the load promise to resolve before interacting
  with gpt, but given that all of their interactions are wrapped with window.googletag.push() waiting for this promise
  to resolve is unnecessary, so long as this util, or edmunds, initializes window.googletag and window.googletag.cmd
  and start downloading gpt.js asynchronously, after that is done this function can return immediately, and DFPManager
  can safely proceed, hence in this fork I am changing this function to return Promise.resolve(window.googletag) - given
  we initialize window.googletag in our ejs;
   todo: consider generalizing my fork to submit a push request to the github, maybe something like
  - add support for an option to DFPManager skipLoadGpt - so any one like edmunds who is loading gpt.js themselves
  via script tag (which is faster than loading via dynamic js injection given that script tag is discovered by browser's
  pre-parser so download starts sooner). After this is merged by them we could start using their library instead of our fork
   */
  return Promise.resolve(window.googletag);
}